import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { Anulicense } from "../license";
import BreadCrumbSection from "../components/breadcrumb_section";

const AboutUsPage = () => {
  let weOffer = [
    {
      image: Anulicense.product1,
      title: "Company History",
      des: "Anu Prints is a service oriented company well established for over 30 years with dedication, sustained effort and hardwork in every endeavour. . As our guiding principal, we have adhere to quality standards and the value of time.",
    },

    {
      image: Anulicense.product2,
      title: "Exclusive Members",
      des: "We are specialized in Multicolor Offset Printing , Graphic Design and Digital Printing. We at Anu Prints, always aspire to align our expertise and excellence with customer preferences.",
    },

    {
      image: Anulicense.services2,
      title: "Working Progress",
      des: "We, at Anu Prints, have always understood the minute details of the customers needs and have been giving the best series in modern day printing. We especially take pride in our ability to develop and deliver exceptional print quality, specific to each client's business.",
    },
  ];

  let clientCommand = [
    "Face-to-Face, ear to ear, we have gathered customer reactions about Printing in order to create a continuous cycle of improvements, more feedfack and even more improvements.",
    "Our myriad colors on quality paper showcase the power of advanced technology blended with exceptional creativity and together with our reasonable rates and prompt delivery and together schedules, has forged postive customer opinion in the most hard-to-please market.",
    "For over two decades, Anu Prints has dedicated itself to the problem of revolutionizing the way man puts his expression in print from. Face-to-Face, ear to ear, more feedfack and even more improvements.",
    "We look forward to a mutually beneficial relationship with your company. For over two decades, Anu Prints has dedicated itself to the problem of revolutionizing the way man puts his expression in print from.",
  ];

  return (
    <div id="anu_aboutus" className="aboutus">
      <BreadCrumbSection page="About Us" />
      <div className="container mx-auto mt-20 pb-20">
        <div className="flex flex-col md:flex-row gap-10 px-6 md:px-10">
          {/* Image Section */}
          <div className="w-full md:w-1/2">
            <img
              src={Anulicense.printProduct}
              alt="About Anu Prints"
              className="block align-top"
            />
          </div>

          {/* Content Section */}
          <div className="w-full md:w-1/2 flex flex-col justify-center relative z-10">
            {/* Highlight Title */}
            <h4 className="font-bold text-[#aa8210] text-[18px] md:text-[24px] leading-[30px] md:leading-[60px] font-secondary_font">
              Needs Any Helps
            </h4>

            {/* Main Title */}
            <h2 className="text-[28px] md:text-[50px] font-medium leading-[35px] md:leading-[60px]">
              Printing Your Dream Works With Anu Prints
            </h2>

            {/* Background Text */}
            <span className="font-secondary_font shadow-text-rigth">
              About
            </span>

            {/* Description */}
            <p className="mt-6 text-gray-700 leading-[30px] pl-2 md:pl-10">
              The Complete Print & Design Studio – Crafted for Your Brand
              At Anu Printers, we are more than just a printing firm — we are your creative collaborators in crafting high-impact visual communication. Established with a vision to blend creativity with precision, we specialize in a comprehensive range of services that include graphic design, offset printing, digital printing, signage solutions, and custom corporate gifting.

              From the first sketch to the final product, we offer a seamless, end-to-end solution for businesses looking to make a bold and memorable impression. Whether you need marketing material that speaks volumes, vibrant digital prints, sophisticated packaging, indoor/outdoor signage, or personalized gifts that leave a mark — we handle every detail with passion and perfection.

              Driven by innovation and backed by cutting-edge technology, our team of designers, printers, and branding experts work relentlessly to deliver products that reflect quality, creativity, and professionalism. We believe that great printing is not just about ink on paper — it’s about telling your story, building your brand, and connecting with your audience.

              At Anu Printers, your vision is our blueprint. Let’s create something remarkable together.
            </p>
          </div>
        </div>
      </div>

<div className="bg-[#f5f6fa]">
  <div className="container mx-auto">
    <div className="flex justify-center items-center pt-20 pb-10">
      <div className="sm:w-1/2 w-full z-10 text-center relative">
        <h4 className="lg:text-[24px] xl:text-[24px] md:text-[24px] text-[18px] leading-[30px] font-secondary_font font-bold text-[#aa8210]">
          What We Offers
        </h4>
        <h2 className="lg:text-[50px] text-[28px] leading-[35px] md:text-[50px] md:leading-[60px] font-medium">
          We Provide Lot’s Of Printing & Branding Service
        </h2>
        <span className="font-secondary_font text-[90px] md:text-[150px] shadow-text">
          Services
        </span>
      </div>
    </div>

    <div className="container mx-auto pb-20">
      <div className="flex flex-col md:flex-row flex-wrap justify-center items-center gap-6 px-3">
        {weOffer.map((D, idx) => (
          <div key={idx} className="max-w-[400px] w-full md:w-[90%] lg:w-[30%]">
            <div className="relative">
              <img
                src={D.image}
                alt={D.title}
                className="rounded-md h-[250px] w-full object-cover"
              />
              <div className="bg-white shadow-md p-6 mt-[-60px] relative z-10 mx-4 rounded-md text-center">
                <div className="absolute right-[20px] top-[-20px] w-[40px] h-[40px] bg-gradient-to-r from-primary to-secondary flex items-center justify-center rounded-md">
                  <span className="text-white text-xl">→</span>
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-3">{D.title}</h2>
                <p className="text-gray-600 leading-relaxed">{D.des}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</div>


<div className="container mx-auto">
  {/* Section 1: Image Left, Text Right */}
  <div className="flex flex-col md:flex-row">
    <img
      src={Anulicense.ourWork14}
      alt="img"
      className="w-full md:w-1/2 order-1 md:order-1"
    />
    <div className="bg-primary py-20 px-10 w-full md:w-1/2 order-2 md:order-2">
      <div className="text-white font-global_font">
        <h4 className="font-secondary_font text-[12px] text-[#fec931]">
          Why choose
        </h4>
        <h2 className="text-[20px] mb-5">Welcome to Anu Prints</h2>
        <p>
          Anu Offset Printers is your trusted partner for premium-quality offset printing, delivering excellence with every print.
        </p>
      </div>
    </div>
  </div>

  {/* Section 2: Text Left, Image Right on Desktop, Reverse on Mobile */}
  <div className="flex flex-col md:flex-row">
    <div className="bg-primary py-20 px-10 w-full md:w-1/2 order-2 md:order-1">
      <div className="text-white font-global_font">
        <h4 className="font-secondary_font text-[12px] text-[#fec931]">
          Why choose
        </h4>
        <h2 className="text-[20px] mb-5">Welcome to Anu Prints</h2>
        <p>
          We thank you, our most valued customer for the support and continuous
          patronage you have given us all these years...
        </p>
      </div>
    </div>
    <img
      src={Anulicense.ourWork14}
      alt="img"
      className="w-full md:w-1/2 order-1 md:order-2"
    />
  </div>
</div>


      <div className="bg-[#f5f6fa] ">
        <div className="container mx-auto">
          <div className="pt-20 text-center">
            <div className="mx-auto w-full lg:w-3/5 relative z-10">
              <h4 className="font-bold text-[#aa8210] font-secondary_font text-[18px] md:text-[24px] leading-[30px] md:leading-[60px]">
                The Journey of print
              </h4>
              <h2 className="font-medium text-[28px] md:text-[50px] leading-[35px] md:leading-[60px]">
                Looking For Ways to Impress your Clientele?
              </h2>
            </div>
          </div>

          <div className="w-full pt-10 px-10 testimonial-carousel">
            <Swiper
              centeredSlides={true}
              spaceBetween={20}
              modules={[Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 3,
                },
                1024: {
                  slidesPerView: 3,
                },
              }}
            >
              {clientCommand.map((M) => {
                return (
                  <SwiperSlide className="flex justify-center items-center mt-10">
                    <div className="relative bg-white p-[40px] rounded-md testimonial-card mb-20">
                      <p className="text-gray-800 leading-relaxed">{M}</p>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsPage;
